import { Link, Outlet } from 'react-router';
import { canUseAdmin, roleHome } from '@/auth/roles';
import { useStaffSession } from '@/auth/react';
import { buttonClasses } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';
import { StaffHeader } from '@/shells/StaffHeader';

/**
 * Platform administration is for the platform super admin only. Any other role sees "Not allowed" under the
 * plain header, with no admin shell, and the admin screen is not mounted. A hint for what to show; the
 * backend still decides every request.
 */
export function AdminGate() {
  const role = useStaffSession()?.user.role;
  if (!role) return null;
  if (!canUseAdmin(role)) {
    const home = roleHome(role);
    return (
      <div className="flex min-h-dvh flex-col bg-canvas">
        <StaffHeader title="Admin" />
        <main id="main" tabIndex={-1} className="flex-1 px-4 py-4 md:px-6">
          <EmptyState
            icon="alert"
            title="Not allowed"
            message="You don't have access to platform administration."
            action={
              <Link to={home} className={buttonClasses({ variant: 'secondary' })}>
                Go to your home screen
              </Link>
            }
          />
        </main>
      </div>
    );
  }
  return <Outlet />;
}
